import { Component } from '@angular/core';

@Component({
  selector: 'app-short-url',
  templateUrl: './short-url.component.html',
  styleUrls: ['./short-url.component.scss'],
  standalone: true
})
export class ShortUrlComponent {

}
